import React from 'react'
import { Button, Form, FormGroup } from 'reactstrap'
import { Field, formValueSelector, reduxForm } from 'redux-form'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import FormItem from '../../../common/forms/FormItem'
import DatePicker from '../../../common/forms/input/DatePicker'
import { isRequired } from '../../../../utils/validators'
import FormFooter from '../../../common/forms/FormFooter'
import CitySelect from '../../../common/forms/select/CitySelect'
import { tzNormalizeDate } from '../../../../utils/date'
import { INT_DATE_FORMAT } from '../../../../config/locale'
import { getExportRegisteredBusFleet } from '../../../../actions'

const selector = formValueSelector('MaintenanceBusFleetSearchForm')

const MaintenanceBusFleetSearchForm = ({
  handleSubmit,
  loading,
  fromDateStringValue,
  toDateStringValue,
  dispatchGetExportRegisteredBusFleet
}) => {

  const handleExport = () => {
    const fromDateString = tzNormalizeDate({ date: fromDateStringValue, format: INT_DATE_FORMAT })
    const toDateString = tzNormalizeDate({ date: toDateStringValue, format: INT_DATE_FORMAT })
    dispatchGetExportRegisteredBusFleet({ fromDateString, toDateString })
  }

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Ciudad" required>
          <Field
            name="city"
            component={CitySelect}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Desde" required>
          <Field
            name="fromDateString"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Hasta" required>
          <Field
            name="toDateString"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormFooter
        saveButtonText="Buscar"
        saveButtonIcon="fa fa-search"
        saveButtonColor="secondary"
        saveButtonDisabled={loading}
      >
        <Button color="success" onClick={handleExport} disabled={loading} className="mr-2">
          <i className="fa fa-file-excel-o" />
          {' '} Exportar
        </Button>
      </FormFooter>
    </Form>
  )
}

MaintenanceBusFleetSearchForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchGetExportRegisteredBusFleet: PropTypes.func.isRequired,
  fromDateStringValue: PropTypes.string.isRequired,
  toDateStringValue: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => ({
  fromDateStringValue: selector(state, 'fromDateString'),
  toDateStringValue: selector(state, 'toDateString'),
})


const mapDispatchToProps = {
  dispatchGetExportRegisteredBusFleet: getExportRegisteredBusFleet
}

const form = reduxForm({
  form: 'MaintenanceBusFleetSearchForm'
})(MaintenanceBusFleetSearchForm)

export default connect(mapStateToProps, mapDispatchToProps)(form)